const Loading = () => (
    <>Загрузка информации...</>
)

export default Loading